import React, { Component } from 'react';

function Animations() {
  return (
    <div id="animations" />
  )
}

export default Animations;



// WEBPACK FOOTER //
// ./src/components/Animations.js